// utils/logging/debugLog.js

const DEBUG_DAISY = process.env.REACT_APP_DEBUG_DAISY === 'true';

export const debugLog = (...args) => {
  if (DEBUG_DAISY) {
    console.log(...args);
  }
};

export const debugWarn = (...args) => {
  if (DEBUG_DAISY) {
    console.warn(...args);
  }
};

export const debugGroup = (label, callback) => {
  if (!DEBUG_DAISY) return;

  console.group(label);

  try {
    callback?.();
  } finally {
    console.groupEnd();
  }
};